import React from 'react'
import Footerr from '../assets/images/PlayerScreen/Footer.svg'
import '../assets/css/PlayerSubScreen.css'
import back from '../assets/images/Common/back.svg'
import start from '../assets/images/Common/start.svg'
import next from '../assets/images/Common/next.svg'
import { Link } from "react-router-dom";


const Footer = ({BackPage, NextPage, BackText, setNextNav}) => {
  return (
    <>

      <div className="row pt-2" >
        {/* <div className="col-12 "><hr className='player-screen-body-text-line mt-3 ' /></div> */}
        <div className="col-12 ">

          <div className="row">

            <div className="col-lg-6 col-md-12 " style={{ width: "100%" }}>
              <img className='pl-4' style={{ width: "100%" }} src={Footerr} alt="" />
            </div>

            <div className="col-lg-6 col-md-12 pr-4 pl-0 mb-3">

              <div className=' mr-2' style={{ border: "1.5px solid #D6A15E", borderRadius: "12px" }}>

                <div className="row px-4">

                  <div className="col-4 py-2 px-4" style={{ width: "100%" }}>
                    <Link to={BackPage} ><button style={{ width: "100%", borderRadius: "84px", height: "55px", color: "#D6A15E", fontWeight: "700", background: "rgba(0, 0, 0, 0.3)", border: "1.5px solid #D6A15E" }}> {BackText? <i class="fa fa-home"  aria-hidden="true"></i> : <img style={{ height: "29%", marginBottom: "2%" }} src={back} alt="" /> } <span> {BackText? "WELCOME" : "BACK"} </span> </button> </Link> 
                  </div>

                  <div className="col-4 py-2 px-1" style={{ width: "100%" }}>
                    <Link to=".." ><button style={{ width: "100%", borderRadius: "84px", height: "55px", color: "white", fontWeight: "700", background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4125) 100%), #D6A15E", border: "1.5px solid #D6A15E" }}> <span> START <img style={{ height: "29%", marginBottom: "2%" }} src={start} alt="" /> </span> </button> </Link> 
                  </div>

                  <div className="col-4 py-2 px-4" style={{ width: "100%" }}>
                   <Link to={NextPage} > <button onClick={setNextNav} style={{ width: "100%", borderRadius: "84px", height: "55px", color: "#D6A15E", fontWeight: "700", background: "rgba(0, 0, 0, 0.3)", border: "1.5px solid #D6A15E" }}> <span> NEXT <img style={{ height: "29%", marginBottom: "2%" }} src={next} alt="" />  </span> </button> </Link> 
                  </div>

                </div>
                <div className="col-12 d-flex justify-content-center">

                  {/* <p style={{fontSize:"1.5vw", color:"white"}}>Placeholder for contextual helping tips</p> */}

                </div>
              </div>


            </div>

          </div>

        </div>

      </div>

    </>
  )
}

export default Footer